import React, { useEffect, useMemo, useState } from "react";
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";

import { format } from "date-fns";
import { fr } from "date-fns/locale";

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
import DeleteModal from '../../components/Common/DeleteModal';

import {
    getRegistrations as onGetRegistrations,
    addNewRegistration as onAddNewRegistration,
    updateRegistration as onUpdateRegistration,
    deleteRegistration as onDeleteRegistration,

    getStudyLevels as onGetStudyLevels,
    getStudents as onGetStudents,
} from "store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";

import {
    Col,
    Row,
    UncontrolledTooltip,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    Input,
    FormFeedback,
    Label,
    Card,
    CardBody,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Badge,
    Button,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";

const RegistrationStatus = ({ status }) => {
  switch (status) {
    case "PENDING":
      return <Badge className="bg-warning"> En attente </Badge>;

    case "Rejetée":
      return <Badge className="bg-danger"> {status} </Badge>;

    case "VALIDED":
      return <Badge className="bg-success"> Validée </Badge>;

    default:
      return <Badge className="bg-success"> {status} </Badge>;
  }
};

const Registration = () => {

    //meta title
    document.title = "Inscriptions | CinzanEdu";

    const [modal, setModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [registration, setRegistration] = useState(null);
    


 

    // validation
    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            uid: (registration && registration.uid) || '',
            student_id: (registration && registration.student_id) || '',
            class_room_id: (registration && registration.class_room_id) || '',
            academic_year: (registration && registration.academic_year) || '',
            amount: (registration && registration.amount) || '',
            
        },
        validationSchema: Yup.object({
           
            student_id: Yup.number().required("Veuillez sélectionner l'étudiant"),
            class_room_id: Yup.number().required("Veuillez sélectionner la classe"),
            academic_year: Yup.number().required("Veuillez saisir l'année academique"),
            amount: Yup.number().required("Veuillez saisir le montant"),
            
  
        }),
        onSubmit: (values) => {
            if (isEdit) {
                //const payload = { series_category: values }
                const registration = {
                    //id: values.id,
                    uid: values.uid,
                    student_id: values.student_id,
                    class_room_id: values.class_room_id,
                    academic_year: values.academic_year,
                    amount: values.amount,
                    
                };
                // update movie category
                dispatch(onUpdateRegistration(registration));
                validation.resetForm();
            } else {
                const newRegistration = {
                    //id: values["id"],
                    //uid: values["uid"],
                   
                    student_id: values["student_id"],
                    class_room_id: values["class_room_id"],
                    academic_year: values["academic_year"],
                    amount: values["amount"],
                   
                };
                // save new movie category
                dispatch(onAddNewRegistration(newRegistration));
                validation.resetForm();
            }
            toggle();
        },
    });

    const dispatch = useDispatch();

    const RegistrationProperties = createSelector(
        (state) => state.registrationReducer, 
        (registrationReducer) => ({
            registrations: registrationReducer.registrations,
            loading: registrationReducer.loading
        })
    );

    const {registrations, loading} = useSelector(RegistrationProperties);

    const [isLoading, setLoading] = useState(loading)


     // Selector Study level
    const StudyLevelProperties = createSelector(
        (state) => state.studyLevelReducer, 
        (studyLevelReducer) => ({
            studyLevels: studyLevelReducer.studyLevels,
            loading: studyLevelReducer.loading
        })
    );

    const {studyLevels} = useSelector(StudyLevelProperties);


     // Students
    const StudentProperties = createSelector(
        (state) => state.studentReducer, 
        (studentReducer) => ({
            students: studentReducer.students,
            loading: studentReducer.loading
        })
    );

    const {students} = useSelector(StudentProperties);

    

    useEffect(() => {
        if (registrations && !registrations.length) {
            dispatch(onGetRegistrations());
        }

        if (studyLevels && !studyLevels.length) {
            dispatch(onGetStudyLevels());
        }

        if (students && !students.length) {
            dispatch(onGetStudents());
        }
    }, [dispatch, registrations.length, studyLevels.length, !students.length]);



   


    

  

    const toggle = () => {
        if (modal) {
            setModal(false);
            setRegistration(null);
        } else {
            setModal(true);
        }
    };

    const handleRegistrationClick = arg => {
        const registration = arg;
        setRegistration({
            id: registration.id,
            uid: registration.uid,
            student_id: registration.student_id,
            class_room_id: registration.class_room_id,
            academic_year: registration.academic_year,
            amount: registration.amount,
           
        });


        // Set for update url
        setIsEdit(true);

        toggle();
    };

    //delete Serial movie
    const [deleteModal, setDeleteModal] = useState(false);

    const onClickDelete = (registration) => {
        setRegistration(registration);
        setDeleteModal(true);
    };

    const handleDeleteRegistration = () => {
        if (registration && registration.id) {
            //dispatch(onDeleteSerialeventCategory(serialeventCategory.id));
            dispatch(onDeleteRegistration(registration));
            setDeleteModal(false);
        }
    };

    const onClickNewRegistration = () => {
        setIsEdit(false);
        setRegistration(null);
        toggle();
        //setModal(true)
    };

    const columns = useMemo(
        () => [
            {
                header: 'ID',
                accessorKey: "id",
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return <Link to="#" className="text-body fw-bold">{cellProps.row.original.id}</Link>
                }
            },
            {
                header: "Date",
                accessorKey: "created_at",
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    const dateStr = cellProps.row.original.created_at;
                    return format(dateStr, "dd/MM/yyyy", { locale: fr }); 
                },
                
            },
            {
                header: "Matricule étudiant",
                accessorKey: "student_number", 
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    const student = cellProps.row.original.student;
                    if (!student) return "-";
                    return `${student.student_number}`;
                },
            },
            {
                header: "Nom et prenom",
                accessorKey: "student", 
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    const student = cellProps.row.original.student;
                    if (!student) return "-";
                    return `${student.first_name} ${student.last_name}`;
                },
            },
            
            {
                header: "Année academique",
                accessorKey: "academic_year.name",
                enableColumnFilter: false,
                enableSorting: true,
            }, 
            {
                header: "Filière",
                accessorKey: "branch.name",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Niveau d'étude",
                accessorKey: "study_level.name",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Statut",
                accessorKey: "status",
                 cell: (cellProps) => <RegistrationStatus status={cellProps.row.original.status} />,
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: 'Action',
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0">
                            {/*
                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-info"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        handleRegistrationClick(jobData);
                                    }}
                                    id={`edittooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-pencil-outline" />
                                    <UncontrolledTooltip placement="top" target={`edittooltip-${cellProps.row.original.id}`} >
                                        Edit
                                    </UncontrolledTooltip>
                                </Link>
                            </li>
                            */}

                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-danger"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        //console.log("ON DELETE: ", jobData);
                                        onClickDelete(jobData);
                                    }}
                                    id={`deletetooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-delete-outline" />
                                    <UncontrolledTooltip placement="top" target={`deletetooltip-${cellProps.row.original.id}`}>
                                        Delete
                                    </UncontrolledTooltip>
                                </Link>
                            </li>
                        </ul>
                    );
                }
            },
        ],
        []
    );

    return (
        <React.Fragment>
            <DeleteModal
                show={deleteModal}
                onDeleteClick={handleDeleteRegistration}
                onCloseClick={() => setDeleteModal(false)}
            />
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Inscriptions" breadcrumbItem="Liste des inscriptions" />
                    {
                        isLoading ? <Spinners setLoading={setLoading} />
                            :
                            <Row>
                                <Col lg="12">
                                    <Card>
                                        <CardBody className="border-bottom">
                                            <div className="d-flex align-items-center">
                                                <h5 className="mb-0 card-title flex-grow-1"></h5> 
                                                <div className="flex-shrink-0">
                                                    {/*<Link to="#!" onClick={onClickNewRegistration} className="btn btn-primary me-1">Ajouter une inscription</Link>*/}
                                                    
                                                </div>
                                            </div>
                                        </CardBody>
                                        <CardBody>
                                            <TableContainer
                                                columns={columns}
                                                data={registrations || []}
                                                isCustomPageSize={true}
                                                isGlobalFilter={true}
                                                //isJobListGlobalFilter={false}
                                                isPagination={true}
                                                SearchPlaceholder="Rechercher ..."
                                                tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline"
                                                theadClass="table-light"
                      
                        
                                                
                                                //tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                                                pagination="pagination"
                                                paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                            />
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                    }
                    <Modal 
                        isOpen={modal} 
                        toggle={toggle}
                         backdrop={'static'}
                            id="staticBackdrop"
                    >
                        <ModalHeader toggle={toggle} tag="h4">
                            {!!isEdit ? "Modifier - Inscription" : "Ajouter - Inscription"}
                        </ModalHeader>
                        <ModalBody>
                            <Form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    validation.handleSubmit();
                                    return false;
                                }}
                            >
                                <Row>
                                    <Col className="col-12">
                                       

                                        <div className="mb-3">
                                            <Label>Année academique</Label>
                                            <Input
                                                name="academic_year"
                                                type="text"
                                                placeholder="Année academique"
                                                validate={{
                                                    required: { value: true },
                                                }}
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.academic_year || ""}
                                                invalid={
                                                    validation.touched.academic_year && validation.errors.academic_year ? true : false
                                                }
                                            />
                                            {validation.touched.academic_year && validation.errors.academic_year ? (
                                                <FormFeedback type="invalid">{validation.errors.academic_year}</FormFeedback>
                                            ) : null}
                                        </div>

                                        <div className="mb-3">
                                            <Label>Niveau d'étude</Label>
                                            <Input
                                                name="class_room_id"
                                                type="select"
                                                className="form-select"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={
                                                    validation.values.class_room_id || ""
                                                }
                                                invalid={
                                                    validation.touched.class_room_id && validation.errors.class_room_id
                                                        ? true
                                                        : false
                                                }
                                            >
                                                <option value="">-- Sélectionner --</option>
                                                    {studyLevels.map((c) => (
                                                    <option key={c.id} value={c.id}>{c.name}</option>
                                                    ))}

                                            </Input>
                                            {validation.touched.class_room_id && validation.errors.class_room_id ? (
                                                <FormFeedback type="invalid">{validation.errors.class_room_id}</FormFeedback>
                                            ) : null}
                                        </div>


                                        <div className="mb-3">
                                            <Label>Étudiant</Label>
                                            <Input
                                                name="student_id"
                                                type="select"
                                                className="form-select"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={
                                                    validation.values.student_id || ""
                                                }
                                                invalid={
                                                    validation.touched.student_id && validation.errors.student_id
                                                        ? true
                                                        : false
                                                }
                                            >
                                                <option value="">-- Sélectionner --</option>
                                                    {students.map((c) => (
                                                    <option key={c.id} value={c.id}>{c.name}</option>
                                                    ))}

                                            </Input>
                                            {validation.touched.student_id && validation.errors.student_id ? (
                                                <FormFeedback type="invalid">{validation.errors.student_id}</FormFeedback>
                                            ) : null}
                                        </div>

                                        <div className="mb-3">
                                            <Label>Montant</Label>
                                            <Input
                                                name="amount"
                                                type="numeric"
                                                placeholder="Montant"
                                                validate={{
                                                    required: { value: true },
                                                }}
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.amount || ""}
                                                invalid={
                                                    validation.touched.amount && validation.errors.amount ? true : false
                                                }
                                            />
                                            {validation.touched.amount && validation.errors.amount ? (
                                                <FormFeedback type="invalid">{validation.errors.amount}</FormFeedback>
                                            ) : null}
                                        </div>
                                       
                                       
                                        
                                       

                                        

                                        
                                        
                                        
                                        
                                        
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <div className="text-end">
                                            <Button color="btn btn-primary me-1"
                                                type="submit"
                                                className="save-user"
                                            >
                                                
                                                {!!isEdit ? "Modifier " : "Enregistrer"}
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>
                            </Form>
                        </ModalBody>
                    </Modal>
                </div>
            </div>
            <ToastContainer />
        </React.Fragment>
    );
}


export default Registration;